import Styled from "styled-components";

export default Styled.div`
   button.notificationBtn {
    margin-top: 7em;
   }
`;
